import script from "./CoverflowCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./CoverflowCarousel.vue?vue&type=script&setup=true&lang=js"

import "./CoverflowCarousel.vue?vue&type=style&index=0&id=513d73b0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-513d73b0"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon});
